import React from 'react';
import DateRange from '../molecules/DateRange'
import CourierFilter from '../molecules/CourierFilter'

const FilterCard = (props) => {
    const { className }  = props;
  
    return (
        <div className={`${className} bg-white rounded shadow p-4`}>
            <h5>Filter</h5>
            <br/>
            <div className="row">
                <div className="col-6">
                    <DateRange
                        onSetFromDate={props.onSetFromDate}
                        onSetToDate={props.onSetToDate}
                    />
                </div>
                <div className="col-4">
                    <CourierFilter
                        selectedCouriers={props.selectedCouriers}
                        onClickFilter={props.onClickFilter}
                    />
                </div>
            </div>
        </div>
    );
};

export default FilterCard;
